import React from "react";

function TextView({text}) {
  return (
    <span className="whitespace-pre-wrap">
      {text}
    </span>
  );
}

export default TextView;
